import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";
import { mediaUrl } from "@/lib/api";
import { X, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CartDrawer = () => {
  const { items, open, setOpen, removeItem } = useCart();
  const { formatValue, convert } = useCurrency();
  const subtotal = items.reduce((s, i) => s + convert(i.price), 0);
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/70 z-[60] transition-opacity duration-500 ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setOpen(false)}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-[#0A0A0A] border-l border-white/10 z-[70] flex flex-col transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-7 py-6 border-b border-white/10">
          <span className="font-mono-label text-xs uppercase tracking-luxe text-white/60">
            Your Bag ({items.length})
          </span>
          <button data-testid="cart-close-btn" onClick={() => setOpen(false)} className="text-white/70 hover:text-white">
            <X strokeWidth={1.3} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-7 py-6">
          {items.length === 0 ? (
            <p className="text-white/40 text-sm mt-10 text-center font-mono-label uppercase tracking-luxe">
              Your bag is empty
            </p>
          ) : (
            <ul className="space-y-7">
              {items.map((i) => (
                <li key={i.product_id} data-testid="cart-item" className="flex gap-4">
                  <div className="w-20 h-28 bg-neutral-900 shrink-0 overflow-hidden">
                    {i.image && <img src={mediaUrl(i.image)} alt={i.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 flex flex-col">
                    <div className="flex justify-between gap-2">
                      <p className="text-sm text-white">{i.name}</p>
                      <button
                        data-testid="cart-item-remove"
                        onClick={() => removeItem(i.product_id)}
                        className="text-white/40 hover:text-white"
                      >
                        <Trash2 strokeWidth={1.3} size={15} />
                      </button>
                    </div>
                    <p className="font-mono-label text-xs text-white/40 mt-1 uppercase tracking-luxe">Size {i.size}</p>
                    <div className="mt-auto flex items-center justify-between">
                      <span className="font-mono-label text-[10px] uppercase tracking-luxe text-white/30">One-of-one</span>
                      <span className="font-mono-label text-sm text-white">{formatValue(convert(i.price))}</span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-white/10 px-7 py-6 space-y-5">
            <div className="flex justify-between text-white">
              <span className="font-mono-label text-xs uppercase tracking-luxe text-white/60">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-mono-label text-sm">{formatValue(subtotal)}</span>
            </div>
            <button
              data-testid="cart-checkout-btn"
              onClick={() => {
                setOpen(false);
                navigate("/cart");
              }}
              className="w-full bg-white text-black py-4 font-mono-label text-xs uppercase tracking-luxe hover-invert hover:bg-transparent hover:text-white border border-white"
            >
              Review & Checkout
            </button>
          </div>
        )}
      </aside>
    </>
  );
};
